/**
 * What the public shell's language notice says about the page below it (clarified FR-004): nothing,
 * that part of what it shows is only in Romanian, or that all of it is.
 */
export const LANGUAGE_FALLBACK = {
  none: 'NONE',
  partial: 'PARTIAL',
  whole: 'WHOLE',
} as const;
